import { styled } from '@mui/material';

import { PrototypeVerdict, Typography } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { ReportStatistics } from '../../../../types';

export type SummaryContentProps = {
  statistics: ReportStatistics;
  hideHumanReviews?: boolean;
};

const StyledSimStatus = styled('div')({});

const StyledSimStatusValue = styled('strong')(({ theme }) => ({
  fontWeight: 700,
  marginRight: theme.spacing(1),
  minWidth: theme.spacing(14),
  display: 'inline-block',
}));

const StyledSimStatusText = styled(Typography)({
  display: 'inline',
});

const VerdictRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: `${theme.spacing(2)} 0`,
}));

const Content = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const SummaryContent = ({
  statistics,
  hideHumanReviews,
}: SummaryContentProps) => {
  const { t } = useI18n();
  const totalSimulations =
    (statistics.simulatedReviews.succeded || 0) +
    (statistics.simulatedReviews.failed || 0);
  const totalHumanReviews =
    (statistics.humanReviews?.succeded || 0) +
    (statistics.humanReviews?.failed || 0);
  const hasSimulations = totalSimulations > 0;

  if (!hasSimulations)
    return (
      <Content>
        <StyledSimStatus>{t('prototypes:no_simulations')}</StyledSimStatus>
      </Content>
    );

  return (
    <Content>
      <VerdictRow>
        <PrototypeVerdict
          variant="small"
          success={statistics.meetsRequirements}
        />
      </VerdictRow>

      <StyledSimStatus>
        <StyledSimStatusValue>
          {statistics.simulatedReviews.succeded || 0}/{totalSimulations}
        </StyledSimStatusValue>
        <StyledSimStatusText>
          {t('prototypes:passed_n_of_m')}
        </StyledSimStatusText>
      </StyledSimStatus>
      {!hideHumanReviews ? (
        <StyledSimStatus>
          <StyledSimStatusValue>{totalHumanReviews}</StyledSimStatusValue>
          <StyledSimStatusText>
            {t('prototypes:n_human_reviews')}
          </StyledSimStatusText>
        </StyledSimStatus>
      ) : null}
      <StyledSimStatus>
        <StyledSimStatusValue>
          {(
            (statistics.metrics.simulatedInteractions || 0) / totalSimulations
          ).toFixed(1)}
        </StyledSimStatusValue>
        <StyledSimStatusText>
          {t('prototypes:n_average_interactions')}
        </StyledSimStatusText>
      </StyledSimStatus>
      <StyledSimStatus>
        <StyledSimStatusValue>
          {(
            (statistics.metrics.simulationViewsCount || 0) / totalSimulations
          ).toFixed(1)}
        </StyledSimStatusValue>
        <StyledSimStatusText>
          {t('prototypes:n_average_views')}
        </StyledSimStatusText>
      </StyledSimStatus>
    </Content>
  );
};
